import './TypingIndicator.css'

export default function TypingIndicator() {
  return (
    <div className="message assistant">
      <div className="message-bubble typing-indicator">
        <div className="typing-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  )
}


